import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import OrganizerLogin from '../components/auth/OrganizerLogin';

const OrganizerLoginView = () => {
  const navigate = useNavigate();
  const { isAuthenticated, role, loading, signOut, authError, clearAuthError } = useAuth();
  const [loginError, setLoginError] = useState('');
  const [showErrorFromWrongRole, setShowErrorFromWrongRole] = useState(false);

  useEffect(() => {
    if (!loading && isAuthenticated && role && role !== 'organizer') {
      signOut().then(() => {
        setShowErrorFromWrongRole(true);
        setLoginError('Correo o contraseña incorrectos. Intenta de nuevo.');
      });
    }
  }, [isAuthenticated, role, loading, signOut]);

  if (!loading && isAuthenticated && role === 'organizer') {
    return <Navigate to="/organizador/dashboard" replace />;
  }

  const handleBackToHome = () => {
    navigate('/');
  };

  const forcedError = showErrorFromWrongRole ? loginError : (authError || '');

  return (
    <OrganizerLogin
      onBackToHome={handleBackToHome}
      forcedError={forcedError}
      onErrorDisplayed={() => {
        setShowErrorFromWrongRole(false);
        clearAuthError();
      }}
    />
  );
};

export default OrganizerLoginView;
